(function($) {
	

    $(".cb-full-description").click(function() {
        $([document.documentElement, document.body]).animate({
            scrollTop: $(".cb-product-tabs").offset().top - 100
        },400);
    });

    
    $(document).ready(function() {
	    $('.lookbook-slider__items .f-column:first-child').find('.lbcard__popup-btn-trigger').click();
    });

     $(document).ready(function() {
      if ($('.cb-option-custom-size').length) {
        $('[data-size-group="#1"]')?.click();
        $('.cb-option-custom-size input[name="properties[Length]"]').on('input', selectSizeGroup);
        $('.cb-option-custom-size input[name="properties[Width]"]').on('input', selectSizeGroup);
      }
    });
    function selectSizeGroup(){
      var sizeGroups = JSON.parse(document.getElementById('size-groups').textContent);
      var $lengthEl = $('.cb-option-custom-size input[name="properties[Length]"]');
      var $widthEl = $('.cb-option-custom-size input[name="properties[Width]"]');

      var length = Number($lengthEl.val());
      var lengthMin = Number($lengthEl.attr('min'));
      var lengthMax = Number($lengthEl.attr('max'));

      var width = Number($widthEl.val());
      var widthMin = Number($widthEl.attr('min'));
      var widthMax = Number($widthEl.attr('max'));

      if (length < lengthMin || length > lengthMax){
        $lengthEl.addClass('cb-input-error');
        $('button.product-form__submit').addClass('cb-length-error');
        $('[data-shopify="payment-button"]').addClass('cb-length-error');
      } else {
        $('button.product-form__submit').removeClass('cb-length-error');
        $('[data-shopify="payment-button"]').removeClass('cb-length-error');
        $lengthEl.removeClass('cb-input-error');
      }

      if (width < widthMin || width > widthMax) {
        $widthEl.addClass('cb-input-error');
        $('button.product-form__submit').addClass('cb-width-error');
        $('[data-shopify="payment-button"]').addClass('cb-width-error');
      } else {
        $('button.product-form__submit').removeClass('cb-width-error');
        $('[data-shopify="payment-button"]').removeClass('cb-width-error');
        $widthEl.removeClass('cb-input-error');
      }

      if (length >= lengthMin && length <= lengthMax && width >= widthMin && width <= widthMax) {
        var area = length * width / 1000000;
        let prevGroup;
        var matchedGroup = sizeGroups.find(function(group) {
          if (prevGroup && area > prevGroup.sizeTo && area < group.sizeFrom){
            return true;
          } else {
            prevGroup = group;
            return area >= group.sizeFrom && area <= group.sizeTo;
          }
        });
        if (matchedGroup) {
          document.querySelector(`[data-size-group="${matchedGroup.sizeGroupName}"]`)?.click();
          setTimeout(() => {
            $('button.product-form__submit').removeClass('cb-disabled');
            $('[data-shopify="payment-button"]').removeClass('cb-disabled');
          }, 700);
        } 
      }

      function getFixedNumber(num) {
        const parts = num.toString().split(".");
        return parts[1] ? parts[1].length : 0;
      }
    }
  $(document).ready(function() {
    // var height = $('.product__block--cb_variant_picker').height();
    // $('.product__block--cb_variant_picker').css('height', height + 'px');
  });
})(jQuery);

class CBReadMore extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      content: '.read-more__content',
      button: '.read-more__toggle',
      buttonText: '.btn__text',
    };
    this.classes = {
      isDisabled: 'is-disabled',
      isCollapsed: 'is-collapsed',
    };
    
    const elementId = this.id || 'default';
    this.storageKey = `expanded_state_${window.location.pathname}_${elementId}`;
  }

  connectedCallback() {
    // Невелика затримка, щоб Flexbox встиг розкласти свочі
    requestAnimationFrame(() => {
      setTimeout(() => {
        this.init();
      }, 50);
    });
  }

  init() {
    this.buttonEl = this.querySelector(this.selectors.button);
    this.contentEl = this.querySelector(this.selectors.content);
    
    if (!this.buttonEl || !this.contentEl) return;

    this.showText = this.dataset.showText || 'View more';
    this.hideText = this.dataset.hideText || 'View less';
    
    // Поріг, після якого з'являється кнопка (твої 126px з CSS + невеличкий запас)
    this.maxHeightThreshold = 135; 

    this.buttonEl.replaceWith(this.buttonEl.cloneNode(true));
    this.buttonEl = this.querySelector(this.selectors.button);
    this.buttonEl.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggle();
    });

    const savedState = sessionStorage.getItem(this.storageKey);
    this.checkHeight(savedState);
  }

  checkHeight(savedState) {
    // scrollHeight завжди повертає реальну повну висоту ВСІХ свочів, 
    // навіть якщо зараз вони обрізані CSS-правилом до 126px.
    const contentHeight = this.contentEl.scrollHeight;

    if (contentHeight <= this.maxHeightThreshold) {
      // Якщо свочів мало (наприклад, 1 рядок), кнопка не потрібна
      this.buttonEl.style.display = 'none';
      this.classList.add(this.classes.isDisabled);
      this.classList.remove(this.classes.isCollapsed); // розгортаємо повністю
    } else {
      // Якщо свочів багато
      this.buttonEl.style.display = '';
      this.classList.remove(this.classes.isDisabled);
      
      // Застосовуємо збережений стан
      if (savedState === 'expanded') {
        this.showMore(false);
      } else {
        // Якщо збереженого стану немає, або він collapsed, блок вже має клас is-collapsed завдяки HTML
        this.showLess(false); 
      }
    }
  }

  toggle() {
    if (this.classList.contains(this.classes.isCollapsed)) {
      this.showMore(true);
    } else {
      this.showLess(true);
    }
  }

  showMore(saveToStorage = true) {
    this.classList.remove(this.classes.isCollapsed);
    this.buttonEl.querySelector(this.selectors.buttonText).textContent = this.hideText;
    
    if (saveToStorage) sessionStorage.setItem(this.storageKey, 'expanded');
  }

  showLess(saveToStorage = true) {
    this.classList.add(this.classes.isCollapsed);
    this.buttonEl.querySelector(this.selectors.buttonText).textContent = this.showText;
    
    if (saveToStorage) sessionStorage.setItem(this.storageKey, 'collapsed');
  }
}

if (!customElements.get('cb-read-more')) {
  customElements.define('cb-read-more', CBReadMore);
}